module.exports = __webpack_public_path__ + "img/avatar1.25405c8a.png";